import { ApiFieldAsset } from "shared/types/ApiFieldAsset";
import { LogAnalyticsFunctionType } from "../../../apps/myExperience/context/analyticsWrapper/types";
import InventorySubType from "../../enums/InventorySubType";

export interface AdDataType {
  sponsorName?: string;
  sponsorImgUrl: string;
  sponsorContent?: string;
  sponsorUrl?: string;
  sponsorRedirectUrl?: string;
  digitalSpaceId?: string;
  sponsorImgAsset?: ApiFieldAsset;
  spanHeight?: string;
}

export interface SponsorAdArgsType {
  uuid: string;
  orientation: AdOrientation;
  adList: Array<AdDataType>;
  title?: string;
  className?: string;
  displayHeader?: boolean;
  onSponsorAdDisplayChange?: (isVisible: boolean) => void;
  logAnalyticsEvent?: LogAnalyticsFunctionType;
  inventorySubType: InventorySubType;
  disableCloseButton?: boolean;
  showCloseButton?: boolean;
}

export enum AdOrientation {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL"
}

export interface SponsorHeadingArgsType {
  title: SponsorAdArgsType["title"];
  onClose: () => void;
  disableCloseButton?: boolean;
}

export interface SponsorBodyArgsType extends SponsorAdArgsType {
  onClose: () => void;
}
